import { PromoBannerWrap, PromoLeft, PromoLabel, PromoCode, PromoRight, PromoButton, PromoTimerBadge, PromoBonus } from './Packages.styled';
import { useTranslation } from 'react-i18next';

export default function PromoBanner({ timeLeft, promoCode, onApply, applied }) {
	const { t } = useTranslation();
	const minutes = Math.floor(timeLeft / 60);
	const seconds = timeLeft % 60;
	return (
		<PromoBannerWrap>
			<PromoTimerBadge>
				{t('promo.timeLeft')}: {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
			</PromoTimerBadge>
			<PromoLeft>
				<PromoLabel>{t('promo.usePromo')}</PromoLabel>
				<PromoCode applied={applied} onClick={applied ? undefined : onApply}>{promoCode}</PromoCode>
			</PromoLeft>
			<PromoBonus>{t('promo.bonus')}</PromoBonus>
			<PromoRight>
				<PromoButton onClick={applied ? undefined : onApply} disabled={applied} applied={applied}>
					{applied ? t('promo.applied') : t('promo.apply')}
				</PromoButton>
			</PromoRight>
		</PromoBannerWrap>
	);
} 